import styled from "styled-components"
import { SelectContainer } from "@smartdevis/ui/src/Selects"
import { TableInputCell } from "../../../components/table/TableCell.styles"

export const HWFillsSelectContainer = styled(TableInputCell)<{ disabled?: boolean }>`
    ${SelectContainer} {
        background-color: transparent;
    }
`
